module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"astride-aside\"-in-pasadena-california-47c88ef4affc1c4f7130ced2927ba2fb.png";